"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CategoryTimeSeriesData_1 = __importDefault(require("../entity/CategoryTimeSeriesData"));
const __1 = require("..");
const CategoryStub_1 = __importDefault(require("./CategoryStub"));
class CategoryTimeSeriesDataStub extends CategoryTimeSeriesData_1.default {
    constructor({ label = 'test', values = [new __1.TimeSeriesStub(), new __1.TimeSeriesStub()], category = new CategoryStub_1.default(), } = {}) {
        super({
            label,
            values,
            category,
        });
    }
}
exports.default = CategoryTimeSeriesDataStub;
